import { render } from "./DrugFact.vue?vue&type=template&id=7ebb9886"
import script from "./DrugFact.vue?vue&type=script&lang=js"
export * from "./DrugFact.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__